import { t } from '@lingui/macro'
import { Typography } from '@mui/material'
import { myI18n } from 'translation/I18nConnectedProvider'

export const ActionsColumnHeader = () => (
  <Typography sx={{ fontWeight: '600', fontSize: '14px', padding: '8px' }}>
    {myI18n._(t`Actions`)}
  </Typography>
)
